import { ImageWidget } from "~/types/widgets";
import Image from "~/components/ui/Image";

interface Props {
  /** @title Título da seção */
  title?: string;
  /** @title Texto descritivo */
  text?: string;
  /** @title Imagem do QR Code */
  qrCodeImage?: ImageWidget;
  /** @title Alt text da imagem */
  qrCodeAlt?: string;
  /** @title Link do app (opcional) */
  appLink?: string;
}

function AppQRCode({
  title = "Baixe nosso app",
  text,
  qrCodeImage,
  qrCodeAlt = "QR Code para baixar o app",
  appLink,
}: Props) {
  if (!qrCodeImage) return null;

  return (
    <div className="flex flex-col items-center justify-center text-center">
      {title && (
        <h3 className="text-sm xl:text-base text-[#333333] mb-4 mt-[30px] xl:mt-0 font-bold font-['Poppins']">
          {title}
        </h3>
      )}

      <div className="flex items-start gap-4">
        <div className="flex flex-col items-center">
          {appLink
            ? (
              <a
                href={appLink}
                target="_blank"
                rel="noopener noreferrer"
                className="block"
              >
                <Image
                  loading="lazy"
                  fetchPriority="low"
                  width={140}
                  height={140}
                  src={qrCodeImage}
                  alt={qrCodeAlt}
                />
              </a>
            )
            : (
              <Image
                loading="lazy"
                fetchPriority="low"
                width={140}
                height={140}
                src={qrCodeImage}
                alt={qrCodeAlt}
              />
            )}
        </div>

        {text && (
          <div className="text-[13px] text-[#434343] font-['Poppins'] max-w-50 text-left leading-relaxed normal-case">
            {text}
          </div>
        )}
      </div>
    </div>
  );
}

export default AppQRCode;
